import './header.scss';

import { isElementPartiallyInViewport, getRootCssVariable } from '../helpers/helpers';

export class Header {
    constructor(target) {
        this.settings = {
            transitionDuration: 250,
            breakpoint: 1150,
            targetOffset: getRootCssVariable('--header-anchor-offset') || 24,
        };

        this.classes = {
            topNav: 'header-top-nav',
            active: 'is-active',
            itemLink: 'nav__link',
            open: 'is-open',
            scrolled: 'is-scrolled',
            toggle: 'header__hamburger',
        };

        this.element      = $(target);
        this.body         = $(document.body);
        this.mobileToggle = this.element.find(`.${this.classes.toggle}`);

        this.scrollStart = 0;
        this.ticking     = false;

        this.isPowerTheme     = this.body.hasClass('station-power');
        this.isDefaultPage    = $('.section--page').length;
        this.defaultPageTitle = $('.section--page').find('.section__title');

        this.sections = $('.main > section');
        this.navLinks = this.element.find('.nav__link');

        this.element[0].headerInstance = this;

        this.init();
    }

    init() {
        this.mobileToggle.on('click', this.toggleMobileMenu.bind(this));
        $(`.${this.classes.topNav}`).on('click', this.onTopNavClick.bind(this));
        $(`.${this.classes.topNav} .nav__item:not(.is-current)`).on('click', this.onTopNavItemClick.bind(this));

        this.repositionTopNav();

        this.navLinks.on('click', this.closeMobileMenu.bind(this));

        $(window).on('scroll load', this.onScroll.bind(this));
        $(window).on('resize', this.repositionTopNav.bind(this));
    }

    toggleMobileMenu(event) {
        event.preventDefault();
        this.element.toggleClass(this.classes.open);

        const target           = $(event.currentTarget);
        const onText           = target.data('on-text');
        const pressedAttribute = 'aria-pressed';
        const offText          = target.data('off-text');
        const pressed          = target.attr(pressedAttribute) === 'true' ? false : true;
        const buttonText       = pressed ? onText : offText;

        target.attr(pressedAttribute, pressed ? 'true' : 'false');
        target.find('.header__hamburger-text').text(buttonText);
    }

    closeMobileMenu() {
        if (this.element.hasClass(this.classes.open)) {
            this.mobileToggle.click();
        }
    }

    setScrolledState() {
        const currentPosition = window.pageYOffset || document.documentElement.scrollTop;

        this.scrollStart = (this.scrollStart === 0) ? currentPosition : this.scrollStart;

        if (currentPosition < 12) {
            this.body.removeClass(this.classes.scrolled);
            this.scrollStart = currentPosition;
        } else {
            this.body.addClass(this.classes.scrolled);
            this.scrollStart = currentPosition;
        }

        this.scrollStart = currentPosition;
    }

    repositionTopNav() {
        window.repositionTopNavWidthChange = this.settings.breakpoint;

        const isChangeDown = !window.repositionTopNavIsChangeDown && window.innerWidth < window.repositionTopNavWidthChange;
        const isChangeUp   = !window.repositionTopNavIsChangeUp && window.innerWidth > window.repositionTopNavWidthChange;

        if (!isChangeDown && !isChangeUp) {
            return;
        }

        const targetLocation = isChangeUp ? this.element : this.element.find('.header__sub-inner');

        $(`.${this.classes.topNav}`).detach()[isChangeUp ? 'insertBefore' : 'prependTo'](targetLocation);

        window.repositionTopNavIsChangeDown = isChangeDown;
        window.repositionTopNavIsChangeUp   = isChangeUp;
    }

    onTopNavClick(event) {
        $(event.currentTarget).toggleClass('is-subnav-open');
    }

    // Somehow in mobile click was not working for other nav items so needed to force it
    onTopNavItemClick(event) {
        const href = $(event.currentTarget).find('a').attr('href');

        window.location.href = href;
    }

    activateNavLink(activeSectionId) {
        const findAnchor = this.navLinks.filter(`[href="#${activeSectionId}"], [href*="/#${activeSectionId}"]`);

        if (findAnchor.hasClass('active')) {
            return;
        }

        this.navLinks.removeClass('active');
        findAnchor.addClass('active');
    }

    onScroll() {
        if (!this.ticking) {
            window.requestAnimationFrame(() => {
                this.handleScroll();
                this.ticking = false;
            });

            this.ticking = true;
        }
    }

    handleScroll() {
        if (!this.element.find('.header__nav .nav__link').length) {
            return;
        }

        this.setScrolledState();

        // Header color change when arriving to footer
        const navLinkOffset = this.element.find('.header__nav .nav__link').offset().top;
        const footerOffset  = $('.footer').offset().top;
        const doClassSet    = (navLinkOffset + 18) >= footerOffset; // 10 extra pixels to set it earlier

        if (this.isPowerTheme && this.isDefaultPage) {
            const defaultPageTitleOffset              = this.defaultPageTitle.offset().top;
            const defaultPageTitleHeight              = this.defaultPageTitle.outerHeight();
            const toggleHeaderClassByDefaultPageTitle = (navLinkOffset + 18) >= defaultPageTitleOffset + defaultPageTitleHeight + 16;

            this.element[toggleHeaderClassByDefaultPageTitle ? 'addClass' : 'removeClass']('is-dark');
        }

        this.element[doClassSet ? 'addClass' : 'removeClass']('is-light');

        if (doClassSet) {
            this.element.removeClass('is-dark');
        }

        let sectionToActivate = this.sections[0].id;

        this.sections.map((index, section) => {
            if (isElementPartiallyInViewport(section)) {
                sectionToActivate = section.id;
            }
        });

        if (doClassSet) {
            this.navLinks.removeClass('active');

            return;
        }

        if (sectionToActivate) {
            this.activateNavLink(sectionToActivate);
        } else {
            this.navLinks.removeClass('active');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.js-header');

    elements.forEach((element) => new Header(element));
});
